import { ThemeData } from '@/views/props'
import { defineStore } from 'pinia'

interface Props {
    theme: ThemeData
}
export const useThemeStore = defineStore({
    id: 'theme',
    state: (): Props => ({
        theme: {
            skinType: '',
        }
    }),
    // 开启数据持久化
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'store',
                storage: sessionStorage
            }
        ]
    },
    getters: {
    },
    actions: {

    },
})
